

const inkTerms = {
  controller: 'TermsController',
  controllerAs: '$ctrl',
  template: require('./terms.template.html'),
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
};

angular
  .module('inkfinder')
  .component('inkTerms', inkTerms);



// WEBPACK FOOTER //
// ./components/auth/terms/terms.component.js